import { HomeIcon, ExploreIcon, BasketIcon, AccountIcon, LanguageIcon } from '../../icons/NavIcons';
import {
  Badge,
  BottomItems,
  IconWrapper,
  NavItem,
  NavLabel,
  Rail,
  TopItems,
} from './SideNav.styles';
import type { SideNavItem, SideNavProps } from './SideNav.types';

const iconMap = {
  home: HomeIcon,
  explore: ExploreIcon,
  basket: BasketIcon,
  account: AccountIcon,
  language: LanguageIcon,
} as const;

function renderNavItem(item: SideNavItem) {
  const IconComponent = iconMap[item.icon];
  const hasBadge = item.badge != null && item.badge > 0;
  return (
    <NavItem
      key={item.id}
      $active={item.active}
      onClick={item.onClick}
      type="button"
      aria-label={item.label}
    >
      <IconWrapper>
        {item.icon === 'basket' ? (
          <BasketIcon size={20} count={hasBadge ? item.badge : undefined} />
        ) : (
          <>
            <IconComponent size={20} />
            {hasBadge && <Badge>{item.badge}</Badge>}
          </>
        )}
      </IconWrapper>
      <NavLabel>{item.label}</NavLabel>
    </NavItem>
  );
}

export function SideNav({ items, bottomItems, navigationLabel = 'Main navigation' }: SideNavProps) {
  return (
    <Rail aria-label={navigationLabel}>
      <TopItems>{items.map(renderNavItem)}</TopItems>
      {bottomItems && bottomItems.length > 0 && (
        <BottomItems>{bottomItems.map(renderNavItem)}</BottomItems>
      )}
    </Rail>
  );
}
